import { dashboardChartColors } from '../../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../../common/BarchartColumn';

export const prop = 'gAType';
export const id = 'substantiveColumn';

export const config = (labels) =>
	barchartColumnConfig({
		fullId: id,
		label: labels.substantiveProcedures,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.hxpsps,
				data: [3],
				color: dashboardChartColors.blue[3]
			},
			{
				name: utilLabels.osps,
				data: [2],
				color: dashboardChartColors.blue[2]
			},
			{
				name: utilLabels.psps,
				data: [1],
				color: dashboardChartColors.blue[1]
			}
		]
	});
